<template>
    <div class="finished">
        <h2
            class="page-title color-text font-bold text-28 text-text mb-7 tracking-tight leading-tight"
        >
            <span class="text-primary">
                {{ $t("Congratulations!") }} {{ $t("You are now ") }}
            </span>
            {{ $t("Changemaker") }}
        </h2>
        <div
            class="fireworks relative flex flex-col justify-center items-center"
        >
            <div class="fireworks__inner relative w-full flex-grow">
                <span class="table absolute fire-1">
                    <FireworksIcon1 />
                </span>
                <span class="table absolute fire-2">
                    <FireworksIcon2 />
                </span>
                <span class="table absolute fire-3">
                    <FireworksIcon3 />
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import Button from "../components/UI/Button";
    
    export default {
        name: "Congratulations",

        components: {
            Button
        },

        mounted() {

        },

        methods: {
            
        }
    };
</script>
